export const getFirstThreeWords = (text) => {
    // Удаляем все, что в квадратных скобках
    const cleanedText = text.replace(/\[.*?\]/g, '').trim();
    // Разделяем текст на слова
    const words = cleanedText.split(/\s+/);
    // Получаем первые три слова
    const firstThreeWords = words.slice(0, 3).join(' ');
    return firstThreeWords;
  };